import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InboxFilterBar from '../components/InboxFilterBar.jsx';
import { InboxSplitView } from '../components/InboxSplit/index.js';
import { EventActionModals } from '../components/GeneralActions/index.js';
import { useEventActions } from '../hooks/useEventActions.js';
import { useEventList } from '../hooks/useEventList.js';
import { useWorkQueueContext } from '../context/useWorkQueueContext.js';
import { WORK_QUEUE_PATHS } from '../constants/inboxViews.js';

/**
 * Inbox view — split list | detail | thread.
 * Routes: `/work-queues` and `/work-queues/:eventId`
 */
function InboxViewPage() {
  const navigate = useNavigate();
  const { eventId } = useParams();
  const { scope } = useWorkQueueContext();
  const { askTarget, escalateTarget, openAsk, openEscalate, closeAsk, closeEscalate, skip } =
    useEventActions();

  const { events, inboxListTotal, inboxCriticalCount, total, teamScopeRestricted, loading, error } =
    useEventList(scope);

  // `/inbox` without id → select first event (deep-linkable URL).
  useEffect(() => {
    if (eventId || events.length === 0) return;
    navigate(WORK_QUEUE_PATHS.event(events[0].id), { replace: true });
  }, [eventId, events, navigate]);

  const onSelect = useCallback(
    (id) => {
      navigate(WORK_QUEUE_PATHS.event(id), { replace: true });
    },
    [navigate],
  );

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden">
      <div className="shrink-0">
        <InboxFilterBar />
      </div>

      <InboxSplitView
        events={events}
        inboxListTotal={inboxListTotal}
        inboxCriticalCount={inboxCriticalCount}
        selectedId={eventId}
        onSelect={onSelect}
        onSkip={skip}
        onAsk={openAsk}
        onEscalate={openEscalate}
        scopeTotal={total}
        teamScopeRestricted={teamScopeRestricted}
        loading={loading}
        error={error}
      />

      <EventActionModals
        askTarget={askTarget}
        escalateTarget={escalateTarget}
        onCloseAsk={closeAsk}
        onCloseEscalate={closeEscalate}
      />
    </div>
  );
}

export default InboxViewPage;
